'use strict';

var wishlist = require('../wishlist/wishlist.js');
function swatchSwitch(el) {
  var $swatch = el;
  var $tileParent = $swatch.parents('.product-tile');
  var pid = $tileParent.attr('data-pid');
  var $tileImage = $tileParent.find('.product-tile-image');
  var $tileImageHover = $tileParent.find('.product-tile-image-secondary');
  $tileParent.find('.swatch.selected').removeClass('selected');
  $swatch.addClass('selected');

  //Replace main image and secondary image
  if ($swatch.data('hover-image') && $swatch.data('hover-image') != '') {
    var swatchImageUrl = $swatch.data('hover-image');
    $tileImage.attr('src', swatchImageUrl);
    if ($tileImageHover.length > 0 && $swatch.data('hover-image-secondary')) {
      var swatchSecondaryImageUrl = $swatch.data('hover-image-secondary');
      $tileImage.data('alt-img-url', swatchSecondaryImageUrl);
      $tileImageHover.attr('src', swatchSecondaryImageUrl);
    }
  }

  //replace main link and Quickview link
  var swatchLink = $swatch.parents('.swatch-link');
  var splitSwatchLink = swatchLink.attr('href').split('?');
  var swatchLinkAttributes = splitSwatchLink[1];

  //main Image Link
  var mainImageLink = $tileParent.find('.product-tile-image-link');
  var mainImageLinkSplit = mainImageLink.attr('href').split('?');
  mainImageLink.attr('href', mainImageLinkSplit[0] + '?' + swatchLinkAttributes);

  //main Quickview Link
  var mainQuickViewLink = $tileParent.find('a.quickview');
  if (mainQuickViewLink.length) {
    var mainQuickViewLinkSplit = mainQuickViewLink.attr('href').split('?');
    //this is assuming that every swatch link will not contain a pid in the attributes
    mainQuickViewLink.attr('href', mainQuickViewLinkSplit[0] + '?' + 'pid=' + pid + '&' + swatchLinkAttributes);
  }

  //main Wishlist Link
  if ($swatch.attr('data-wishlistpid')) {
    var mainWishlistLink = $tileParent.find('a.wishlist');
    if (mainWishlistLink.length) {
      mainWishlistLink.attr('data-wishlistpid', $swatch.attr('data-wishlistpid'));

      //Make heart icon accurate
      wishlist.updateWishlistLinkData(mainWishlistLink);
    }
  }
}
function hijackSwatchClick() {
  if (window.isMobile()) {
    $('body').on('click.swatch-link', '.product-tile .swatch-link', function (e) {
      e.preventDefault();
      var $swatch = $(this).find('.swatch');
      module.exports.methods.swatchSwitch($swatch);
    });
  } else {
    $('body').off('click.swatch-link');
  }
}
module.exports = {
  hijackSwatchClick: hijackSwatchClick,
  mouseEnter: function mouseEnter() {
    $('body').on('mouseenter', '.product-tile .swatch', function (e) {
      var $swatch = $(this);
      module.exports.methods.swatchSwitch($swatch);
    });
  },
  resize: function resize() {
    $(window).on('resize', function () {
      module.exports.hijackSwatchClick();
    });
  },
  methods: {
    swatchSwitch: swatchSwitch
  }
};